import { Variant } from '@/Atomic/Atoms/Badge'
import { EnumValue } from '@/Data/typesV2'

export const getVariantForGroup = (group: string | undefined): Variant => {
  switch (group) {
    case 'positive result':
      return 'success'
    case 'in progress':
      return 'info'
    case 'in review':
      return 'warning'
    case 'negative result':
      return 'danger'
    case 'inactive':
      return 'primary'
    default:
      return 'primary'
  }
}

export const getEnumGroup = (
  enumValues: EnumValue[] | undefined,
  rawValue: unknown,
): string | undefined =>
  enumValues?.find((e) => e.value === rawValue)?.data?.group

export const getVariantForEnumValue = (
  enumValues: EnumValue[] | undefined,
  rawValue: unknown,
): Variant => getVariantForGroup(getEnumGroup(enumValues, rawValue))
